import './locales/i18n';
import { lazy } from 'react';

export const Cipher = lazy(() => import('./cipher'));
